import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

const StudentFeeStructure = () => {
  const { studentId } = useParams();

  const months = [
    "Apr","May","Jun","Jul","Aug","Sep",
    "Oct","Nov","Dec","Jan","Feb","Mar"
  ];
  const [calculatedConcession, setCalculatedConcession] = useState(null);
const [applyAmountConcession, setApplyAmountConcession] = useState(false);
const [concessionAmount, setConcessionAmount] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
const [concessionMonths, setConcessionMonths] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [sessions, setSessions] = useState([]);
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [feeStructures, setFeeStructures] = useState([]);

  const [sessionId, setSessionId] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedFS, setSelectedFS] = useState("");

  const [ledgerId, setLedgerId] = useState(null);

  /* ⭐ NEW CONCESSION STATES */
  const [applyConcession, setApplyConcession] = useState(false);
  const [concessionType, setConcessionType] = useState("Rs");
  const [editFeeHead, setEditFeeHead] = useState(null);
const [editAmount, setEditAmount] = useState("");
const handleEditClick = (key, value) => {
  setEditFeeHead(key);
  setEditAmount(value);
};

const updateOneTimeFee = async () => {
  try {
    await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/api/ledgers/update-one-time-fee/${ledgerId}`,
      {
        feeHead: editFeeHead,
        amount: editAmount
      }
    );

    alert("Updated successfully");

    setEditFeeHead(null);
    fetchFeeStructure(); // refresh

  } catch (err) {
    console.error(err);
    alert("Update failed");
  }
};
const updateMonthlyFee = async () => {
  try {
    await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/api/ledgers/update-monthly-fee/${ledgerId}`,
      {
        month: editFeeHead,   // month1, month2...
        amount: editAmount
      }
    );

    alert("Monthly fee updated");

    setEditFeeHead(null);
    fetchFeeStructure();

  } catch (err) {
    console.error(err);
    alert("Update failed");
  }
};
  useEffect(() => {
    fetchFeeStructure();
  }, [studentId]);

  const fetchFeeStructure = async () => {
    try {

      const sessionId = localStorage.getItem("currentSessionId");

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/ledgers/student-fee-structure/${studentId}`,
        { params: { sessionId } }
      );

      setData(res.data);

      if (res.data?.ledgerId) {
        setLedgerId(res.data.ledgerId);
      }

    } catch (err) {
      setError("Failed to load fee structure.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/sessions/allSessions`)
      .then(res => setSessions(res.data));
  }, []);
useEffect(() => {
  const currentSessionId = localStorage.getItem("currentSessionId");

  if (currentSessionId) {
    setSessionId(currentSessionId);
  }
}, [sessions]);
  useEffect(() => {

    if (!sessionId) return;

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses`, {
        params: { sessionId }
      })
      .then(res => setClasses(res.data));

  }, [sessionId]);
const toggleConcessionMonth = (monthIndex) => {
  setConcessionMonths((prev) => ({
    ...prev,
    [monthIndex]: !prev[monthIndex],
  }));
};
const handleApplyConcession = async () => {

  if (!concessionAmount) {
    alert("Enter concession amount");
    return;
  }

  try {

    const payload = {
  feeStructureId: data.feeStructureId,
  studentId: studentId,   // ✅ ADD THIS
  concessionData: {
    feeHeadConcessions: {
      "Monthly Fee": {
        concessionName: "Manual Concession",
        type: concessionType,
        amount: Number(concessionAmount)
      }
    }
  }
};

    console.log("Apply concession payload:", payload);

    const res = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/concession/calculate`,
      payload
    );

    if (res.data.success) {

      const updatedLedger = res.data.updatedLedger;

setCalculatedConcession(updatedLedger);

      alert("Concession calculated");

    }

  } catch (err) {

    console.error(err);

    alert("Failed to calculate concession");

  }

};
const submitConcession = async () => {

  if (!calculatedConcession) {
    alert("Please apply concession first");
    return;
  }

  try {

    await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/api/concession/applyConcession/${ledgerId}`,
      {
        feeHeads: calculatedConcession.feeHeads,
        totalAmountAfterConcession: calculatedConcession.totalAmountAfterConcession
      }
    );

    alert("Concession saved");

    await fetchFeeStructure();

    // ✅ Reset concession UI
    setApplyConcession(false);
    setCalculatedConcession(null);
    setConcessionAmount("");

  } catch (err) {
    console.error(err);
    alert("Failed to apply concession");
  }

};
  useEffect(() => {

    if (!selectedClass) return;

    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/api/sections/${selectedClass}/getSectionsByClassName`,
        { params: { sessionId } }
      )
      .then(res => setSections(res.data));

  }, [selectedClass]);

  useEffect(() => {

    if (!selectedClass || !sessionId) return;

    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/api/feeStructures/getFeeStructureByClass`,
        {
          params: {
            className: selectedClass,
            sessionId: sessionId,
            studentType: "Existing Student",
            studentId: studentId || null
          }
        }
      )
      .then(res => {

        const data = Array.isArray(res.data)
          ? res.data
          : res.data.data || [];

        setFeeStructures(data);

      })
      .catch(err => {
        console.error("Fee structure fetch error:", err);
        setFeeStructures([]);
      });

  }, [selectedClass, sessionId, studentId]);

const updateFeeStructure = async () => {

  if (!selectedFS) {
    alert("Select fee structure");
    return;
  }

  if (!ledgerId) {
    alert("Ledger not found");
    return;
  }

  try {

    const token = localStorage.getItem("token");

    await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/api/ledgers/change-fee-structure/${ledgerId}`,
      {
        feeStructureId: selectedFS
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    alert("Fee structure updated");

    setShowPopup(false);

    fetchFeeStructure();

  } catch (err) {

    console.error(err);

    alert(
      err.response?.data?.message ||
      "Failed to update fee structure"
    );

  }

};

  if (loading) return <div className="p-6">Loading...</div>;
  if (error) return <div className="p-6 text-red-600">{error}</div>;
  if (!data) return <div className="p-6">No data found.</div>;

  const feeHeads = calculatedConcession?.feeHeads || data.feeHeads || {};

  const monthlyFees = months.map((_, i) => data.feeHeads[`month${i + 1}`] || 0);
  const routeFees = months.map((_, i) => feeHeads[`route_month${i + 1}`] || 0);
const concessionMonthlyFees = months.map(
  (_, i) =>
    calculatedConcession?.feeHeads?.[`month${i + 1}`] ??
    data.feeHeads[`month${i + 1}`] ??
    0
);
  const oneTimeFees = Object.entries(feeHeads).filter(
    ([k]) => !k.startsWith("month") && !k.startsWith("route_month")
  );

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto bg-white shadow rounded p-6">

        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">
            Student Fee Structure
          </h2>

          <button
            onClick={() => setShowPopup(true)}
            className="bg-orange-600 text-white px-4 py-2 rounded"
          >
            Change Fee Structure
          </button>
        </div>

        <p className="mb-6">
          <b>Student Name:</b> {data.studentName}
        </p>

        <h3 className="text-lg font-semibold mb-2">One-Time Fees</h3>

        <table className="w-full border mb-8">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2">Fee Head</th>
              <th className="border p-2 text-right">Amount</th>
            </tr>
          </thead>

          <tbody>
            {oneTimeFees.map(([key, value]) => (
  <tr key={key}>
    <td className="border p-2">{key}</td>

    <td className="border p-2 text-right">

      {editFeeHead === key ? (
        <div className="flex gap-2 justify-end items-center">
          <input
            type="number"
            value={editAmount}
            onChange={(e) => setEditAmount(e.target.value)}
            className="border p-1 w-24 text-right"
          />

          <button
            onClick={updateOneTimeFee}
            className="bg-green-600 text-white px-2 py-1 rounded"
          >
            Save
          </button>

          <button
            onClick={() => setEditFeeHead(null)}
            className="bg-gray-400 text-white px-2 py-1 rounded"
          >
            Cancel
          </button>
        </div>
      ) : (
        <div className="flex justify-between items-center">
          ₹{Number(value).toLocaleString("en-IN")}

          <button
            onClick={() => handleEditClick(key, value)}
            className="ml-4 text-blue-600 underline"
          >
            Edit
          </button>
        </div>
      )}

    </td>
  </tr>
))}
          </tbody>
        </table>

        <h3 className="text-lg font-semibold mb-2">Fee Structure</h3>

        <table className="w-full border text-sm">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2">ID</th>
              <th className="border p-2 text-left">Fee Head</th>

              {months.map((m) => (
                <th key={m} className="border p-2 text-right">{m}</th>
              ))}
            </tr>
          </thead>

          <tbody>

            <tr>
              <td className="border p-2 text-center">1</td>
              <td className="border p-2">Monthly Fee</td>

              {monthlyFees.map((amt, i) => {
  const key = `month${i + 1}`;

  return (
    <td key={i} className="border p-2 text-right">

      {editFeeHead === key ? (
        <div className="flex gap-2 justify-end items-center">
          <input
            type="number"
            value={editAmount}
            onChange={(e) => setEditAmount(e.target.value)}
            className="border p-1 w-20 text-right"
          />

          <button
            onClick={updateMonthlyFee}
            className="bg-green-600 text-white px-2 py-1 rounded"
          >
            Save
          </button>

          <button
            onClick={() => setEditFeeHead(null)}
            className="bg-gray-400 text-white px-2 py-1 rounded"
          >
            Cancel
          </button>
        </div>
      ) : (
        <div className="flex justify-between items-center">
          ₹{Number(amt).toLocaleString("en-IN")}

          <button
            onClick={() => handleEditClick(key, amt)}
            className="ml-2 text-blue-600 underline"
          >
            Edit
          </button>
        </div>
      )}

    </td>
  );
})}
            </tr>

            <tr className="bg-green-50">
              <td className="border p-2 text-center">2</td>
              <td className="border p-2">Route Fee</td>

              {routeFees.map((amt, i) => (
                <td key={i} className="border p-2 text-right">
                  {amt}
                </td>
              ))}
            </tr>

          </tbody>
        </table>

        <div className="bg-gray-100 p-4 rounded mt-6">
          <p className="text-lg font-semibold">
            Total Fee: ₹{Number(data.totalAmount || 0).toLocaleString("en-IN")}
          </p>
        </div>

        {/* ⭐ APPLY CONCESSION */}
        <div className="mt-4 flex items-center gap-2">
          <input
            type="checkbox"
            checked={applyConcession}
            onChange={(e) => setApplyConcession(e.target.checked)}
          />
          <label className="font-medium">Apply Concession</label>
        </div>

        {applyConcession && (
          <div className="mt-6 border rounded p-4 bg-orange-50">

            <h3 className="text-lg font-semibold mb-3">
              Concession Structure
            </h3>
<div className="overflow-x-auto">
<table className="w-full border text-sm min-w-[900px]">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border p-2">ID</th>
                  <th className="border p-2 text-left">Fee Head</th>

                  {months.map((m) => (
                    <th key={m} className="border p-2 text-right">{m}</th>
                  ))}
                </tr>
              </thead>

              <tbody>

                <tr>
                  <td className="border p-2 text-center">1</td>
                  <td className="border p-2">Monthly Fee Concession</td>

                  {months.map((m, i) => (
  <td key={i} className="border p-2 text-right">
    <input
      type="number"
      value={concessionMonthlyFees[i] || 0}
      className="w-20 border p-1 text-right"
      readOnly
    />
  </td>
))}

                </tr>

              </tbody>
            </table>
</div>
          <div className="grid grid-cols-4 gap-4 items-end">

  <div>
    <label className="block text-sm mb-1">
      Concession Type
    </label>

    <select
      value={concessionType}
      onChange={(e)=>setConcessionType(e.target.value)}
      className="w-full border p-2"
    >
      <option value="Rs">Rs</option>
      <option value="%">%</option>
    </select>
  </div>

  <div>
    <label className="block text-sm mb-1">
      Amount
    </label>

    <input
      type="number"
      value={concessionAmount}
      onChange={(e)=>setConcessionAmount(e.target.value)}
      className="w-full border p-2"
    />
  </div>

  <button
  type="button"
  onClick={handleApplyConcession}
  className="bg-blue-600 text-white px-5 py-2 rounded"
>
  Apply
</button>

</div>

<div className="mt-6 flex justify-end">
 <button
  type="button"
  onClick={submitConcession}
  className="bg-green-600 text-white px-6 py-2 rounded"
>
  Submit
</button>
</div>

          </div>
        )}

        <div className="mt-6">
          <Link
            to={`/ledger/${studentId}`}
            className="bg-blue-600 text-white px-4 py-2 rounded"
          >
            Back to Ledger
          </Link>
        </div>

      </div>

      {/* CHANGE POPUP */}

      {showPopup && (

        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center">

          <div className="bg-white p-6 rounded shadow w-[500px]">

            <h3 className="text-lg font-semibold mb-4">
              Change Fee Structure
            </h3>

            <div className="space-y-3">

              <select
  value={sessionId}
  disabled
  className="w-full border p-2 bg-gray-100 cursor-not-allowed"
>
                <option value="">Select Session</option>

                {sessions.map(s => (
                  <option key={s._id} value={s._id}>
                    {s.sessionName}
                  </option>
                ))}
              </select>

              <select
                value={selectedClass}
                onChange={e => setSelectedClass(e.target.value)}
                className="w-full border p-2"
              >
                <option value="">Select Class</option>

                {classes.map(c => (
                  <option key={c._id} value={c.className}>
                    {c.className}
                  </option>
                ))}
              </select>

              <select
                value={selectedSection}
                onChange={e => setSelectedSection(e.target.value)}
                className="w-full border p-2"
              >
                <option value="">Select Section</option>

                {sections.map(sec => (
                  <option key={sec._id} value={sec.sectionName}>
                    {sec.sectionName}
                  </option>
                ))}
              </select>

              <select
                value={selectedFS}
                onChange={e => setSelectedFS(e.target.value)}
                className="w-full border p-2"
              >
                <option value="">Select Fee Structure</option>

                {feeStructures.map(fs => (
                  <option key={fs._id} value={fs._id}>
                    {fs.studentType} — {fs.medium} | Class {fs.class}
                  </option>
                ))}
              </select>

            </div>

            <div className="flex justify-end gap-3 mt-6">

              <button
                onClick={() => setShowPopup(false)}
                className="border px-4 py-2 rounded"
              >
                Cancel
              </button>

              <button
                onClick={updateFeeStructure}
                className="bg-blue-600 text-white px-4 py-2 rounded"
              >
                Update
              </button>

            </div>

          </div>

        </div>

      )}

    </div>
  );
};

export default StudentFeeStructure;